import { html } from 'lit-html';
import { AddRecommendationItemJsEnv } from '../models/add_recommendation_item_js_env';

export const FinishMessage = (model: AddRecommendationItemJsEnv) => html`
<h2 class="a-heading_text">${model.recommendationFolderName}に商品を登録しました。</h2>
`;
